/**
 * @desc 获取文件流
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.GetFileStreamRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/allocationMaster/getFileStream`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
